import { GroupRequestApi } from "../DTO/ClientRequest/GroupRequest";
import {
  GroupIdApi,
  isGroupIdResponseDTO,
} from "../DTO/ServerResponseType/Group/GroupId";
import { ServerClient, serverOrigin } from "./Configs";
import { getTypeGuardedVariableAsync } from "./typeGuard";

class GroupServerClient {
  private path = "/group";

  sendToCreateGroupAsync = async (
    groupData: GroupRequestApi
  ): Promise<string | null> => {
    return getTypeGuardedVariableAsync(
      this.sendNewGroupAsync(groupData),
      isGroupIdResponseDTO
    )
      .then((groupIdDTO: GroupIdApi) => {
        alert("Группа успешно создана.");
        return groupIdDTO.groupId;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        return null;
      });
  };

  sendNewGroupAsync = async (group: GroupRequestApi): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(group),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToUpdateGroupModuleStudentFlagAsync = async (
    groupModuleId: string,
    doOpenModuleForStudent: boolean
  ): Promise<void> => {
    let url: string = serverOrigin + this.path + "/module/update/student/flag";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        groupModuleId: groupModuleId,
        openForStudent: doOpenModuleForStudent,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(() => {
        doOpenModuleForStudent
          ? alert("Модуль группы открыт для учащихся.")
          : alert("Модуль группы закрыт для учащихся.");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        alert("Ошибка: " + error.message);
      });
  };
}

let groupServerClient = new GroupServerClient();

export default groupServerClient;
